// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"f38649d0","571":"f38649d0","843":"f38649d0"}[chunkId] + ".chunk.css";
};